export default __webpack_public_path__ + "static/media/Asset 2.11ddc5aa.png";